var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isActive)?_c('transition',{attrs:{"name":"spinner","appear":""}},[_c('div',{staticClass:"spinner-area"},[_c('div',[_c('img',{attrs:{"src":require("@/assets/images/ico_spinner.png"),"alt":""}})]),_c('p',[_vm._v("Loading")])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }